import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../api/supabase';

const statusColor = { POSTED: 'badge-green', DRAFT: 'badge-yellow', VOID: 'badge-red' };

export default function JournalList() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    let query = supabase.from('journal_entries')
      .select('id, entry_number, entry_date, description, reference_type, is_auto_posted, total_debit, total_credit, status, created_by, created_at')
      .order('created_at', { ascending: false })
      .limit(200);
    if (q) query = query.or(`entry_number.ilike.%${q}%,description.ilike.%${q}%`);
    if (statusFilter) query = query.eq('status', statusFilter);
    const { data } = await query;
    setEntries(data || []);
    setLoading(false);
  }, [q, statusFilter]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">Journal Entries</div><div className="page-subtitle">All double-entry postings</div></div>
        <Link to="/journals/new" className="btn btn-primary">+ Manual Journal</Link>
      </div>

      <div className="card">
        <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
          <input className="form-input" placeholder="Search entry number or description..." value={q} onChange={e => setQ(e.target.value)} style={{ maxWidth: 320 }} />
          <div style={{ display: 'flex', gap: 6 }}>
            {[['', 'All'], ['POSTED', 'Posted'], ['DRAFT', 'Draft'], ['VOID', 'Void']].map(([v, l]) => (
              <button key={v} className={`btn btn-sm ${statusFilter === v ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setStatusFilter(v)}>{l}</button>
            ))}
          </div>
        </div>
        {loading ? <div className="spinner" /> : (
          <div className="table-wrapper">
            <table>
              <thead><tr><th>Entry No</th><th>Date</th><th>Description</th><th>Source</th><th style={{ textAlign: 'right' }}>Total DR</th><th style={{ textAlign: 'right' }}>Total CR</th><th>Status</th><th>By</th><th></th></tr></thead>
              <tbody>
                {entries.map(e => (
                  <tr key={e.id} style={{ opacity: e.status === 'VOID' ? 0.5 : 1 }}>
                    <td style={{ fontFamily: 'monospace', fontWeight: 600, color: 'var(--primary)' }}>{e.entry_number}</td>
                    <td>{e.entry_date}</td>
                    <td style={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.description}</td>
                    <td><span className="badge badge-gray" style={{ fontSize: 10 }}>{e.is_auto_posted ? e.reference_type || 'AUTO' : 'MANUAL'}</span></td>
                    <td style={{ textAlign: 'right' }} className="amount">{parseFloat(e.total_debit || 0).toLocaleString()}</td>
                    <td style={{ textAlign: 'right' }} className="amount">{parseFloat(e.total_credit || 0).toLocaleString()}</td>
                    <td><span className={`badge ${statusColor[e.status] || 'badge-gray'}`}>{e.status}</span></td>
                    <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{e.created_by || ''}</td>
                    <td><Link to={`/journals/${e.id}`} className="btn btn-secondary btn-sm">View</Link></td>
                  </tr>
                ))}
                {entries.length === 0 && <tr><td colSpan={9}><div className="empty-state"><div className="empty-state-title">No journal entries yet</div></div></td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
